<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
import ClubOptionalConsents from "~/components/inputs/ClubOptionalConsents.vue";

const local = await getLocale("forms", "club_consent");
import { CLUB_PRIVACY_URL } from "~/utils/constants";
import Perks from "~/components/static/Perks.vue";

const emit = defineEmits(["init", "submit", "decline"]);

defineComponent({
  name: "ClubConsent",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  installment: { type: String, required: true },
  stickyButton: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const clubConsentMain = useState<boolean | null>("clubConsentMain", () => null);
const clubConsent1 = useState<boolean | null>("clubConsent1", () => null);
const clubConsent2 = useState<boolean | null>("clubConsent2", () => null);
const clubConsent3 = useState<boolean | null>("clubConsent3", () => null);
const clubConsent4 = useState<boolean | null>("clubConsent4", () => null);
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="title" class="leading-6" @submit="emit('submit')" :has-sticky-button="stickyButton" header-class="pageTitle mb-4">
      <p class="mb-4" v-html="local.paragraph_1.replace('%d', formatNumber(installment, null))" />
      <p class="mb-4" v-html="local.paragraph_2.replace('%d', CLUB_PRIVACY_URL)" />
      <ClubOptionalConsents
        v-model:main-consent="clubConsentMain"
        v-model:consent1="clubConsent1"
        v-model:consent2="clubConsent2"
        v-model:consent3="clubConsent3"
        v-model:consent4="clubConsent4"
      />
      <template #link>
        <div class="text-center text-gray-700 text-[15px] my-4">
          <button class="underline inline" data-testid="decline" @click="() => $emit('decline')">
            {{ local.continue_without_club }}
          </button>
        </div>
        <div class="spacer h-6" />
      </template>
    </FormCard>
    <template #bottom-out>
      <p class="italic px-4">{{ local.disclaimer }}</p>
    </template>
  </FormContainer>
  <Perks />
</template>

<style scoped></style>
